/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".exampleCheckbox_3d086b79{margin:10px 0}.exampleLabel_3d086b79{margin:10px 0}\n"}]);
export const exampleCheckbox = "exampleCheckbox_3d086b79";
export const exampleLabel = "exampleLabel_3d086b79";